import { render } from "./ListLostAuctions.vue?vue&type=template&id=99460908&scoped=true&ts=true"
import script from "./ListLostAuctions.vue?vue&type=script&lang=ts"
export * from "./ListLostAuctions.vue?vue&type=script&lang=ts"

import "./ListLostAuctions.vue?vue&type=style&index=0&id=99460908&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99460908"]])

export default __exports__